import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { connect } from "react-redux";
import CameraWithOverlayVideo from "../CameraWithOverlayVideo";
import CarDamge from "../Car Damge";
import baseUrlNew from "../BaseUrl/index";
import { useLocation, useParams } from "react-router-dom";
import VehicleNotAttachedScreen from "../components/VehicleNotAttachedScreen";
import SessionLoadingScreen from "../components/SessionLoadingScreen";
import {
  findResumePhotoIndex,
  getGuidedPhotoSteps,
} from "../utils/photoProgress";
import { getcardata } from "../Redux/reduxflow/action";

const queryString = require("query-string");

function ApiCall({ car_pics_data_a, getcardata }) {
  const cur_data = useRef({});
  const { id } = useParams();
  // guided = 16-step camera flow, gallery = edit / retake grid
  const [flow, setFlow] = useState("loading");
  const [resumeIndex, setResumeIndex] = useState(0);
  const [loading, setloading] = useState(true);
  const [linkValid, setLinkValid] = useState(true);
  const location = useLocation();
  const value = queryString.parse(location.search);

  useEffect(() => {
    cur_data.current = car_pics_data_a;
  }, [car_pics_data_a]);

  useEffect(() => {
    resolvePhotoFlow();

    if (!value.view) {
      return undefined;
    }

    function handleEvent() {
      if (window.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage(JSON.stringify(cur_data.current));
      }
    }

    document.addEventListener("message", handleEvent);
    return () => document.removeEventListener("message", handleEvent);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const checkUrl = `${baseUrlNew.baseUrl}api/v1/check_evaluation_photos/`;
  const detailsUrl = `${baseUrlNew.baseUrl}api/v1/evaluation_images_Details/${id}`;

  const openGuided = (index = 0) => {
    setResumeIndex(Math.max(0, index));
    setFlow("guided");
    setloading(false);
  };

  const openGallery = (detailsPayload) => {
    if (detailsPayload && typeof getcardata === "function") {
      getcardata(detailsPayload);
    }
    setFlow("gallery");
    setloading(false);
  };

  const resolvePhotoFlow = async () => {
    try {
      const checkResponse = await axios.post(checkUrl, { pk: id });
      const available = Boolean(checkResponse?.data?.data?.available);

      // First visit / no photos yet → guided capture from the start.
      if (!available) {
        openGuided(0);
        return;
      }

      // Photos exist — resume guided flow if the 16-set is incomplete;
      // only show the edit gallery when every required angle is present.
      const detailsResponse = await axios.get(detailsUrl);
      const details = detailsResponse?.data;
      if (details && typeof getcardata === "function") {
        getcardata(details);
      }

      const steps = getGuidedPhotoSteps();
      const nextIndex = findResumePhotoIndex(details, steps);
      if (nextIndex < steps.length) {
        openGuided(nextIndex);
        return;
      }

      openGallery(details);
    } catch {
      setLinkValid(false);
      setloading(false);
    }
  };

  if (loading || flow === "loading") {
    return <SessionLoadingScreen />;
  }

  if (!linkValid) {
    return <VehicleNotAttachedScreen />;
  }

  return flow === "gallery" ? (
    <CarDamge id={id} />
  ) : (
    <CameraWithOverlayVideo
      id={id}
      close={() => setFlow("gallery")}
      resumeIndex={resumeIndex}
    />
  );
}

const mapStateToProps = (state) => ({
  car_pics_data_a: state.cardata.car_pics_data,
});
const mapDispatchToProps = (dispatch) => ({
  getcardata: (response) => dispatch(getcardata(response)),
});
export default connect(mapStateToProps, mapDispatchToProps)(ApiCall);
